
<template>
  <div>
    <loading 
     :active.sync="loadingTicket" 
        :is-full-page="true"
        color="green"
        ></loading>
   <v-layout>
        <v-btn
        flat
        depressed
        rounded
        @click="clearFilters()"
        color="primary"
        class="white--text"
      >Filter</v-btn>
     
    </v-layout>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name); contactId=null; contactTableId=null"
        >{{tab.displayName}}
         <v-chip :key="key" :color="tab.color" class="white--text">{{tab.array}}</v-chip></v-tab>
      </v-tabs>
    </v-toolbar>

    <!--Pending Tab-->
    <div v-if="displayContents('pending')" @click="contactId=null;">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
         v-model="pendingSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable         
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: pendingSearch,
          resolvedSearch: $route.query.resolvedSearch,
          records: $route.query.records
          }})"        
          ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :pagination.sync="pagination"
        :loading="isLoading"
        :items="pendingList"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.currentStatus}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{props.item.id}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.ticketCategory.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >{{props.item.description}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >{{formatDate(props.item.dueDate)}}</h3>
            <h3
              class="grey--text font-weight-light"
              v-else
            >{{formatDate(props.item.dueDate)}} {{props.item.dueTime}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.importance}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{props.item.createdBy.name}} {{props.item.createdBy.surname}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !==null"
              class="grey--text font-weight-light"
            >{{props.item.assignedTo.name}} {{props.item.assignedTo.surname}}</h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !==null"
              class="grey--text font-weight-light"
            >{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</h3>
          </td>
        </template>
        <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!--Resolved Tab-->
    <div v-if="displayContents('resolved')" @click="contactId=null;">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="resolvedSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
         v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: $route.query.pendingSearch,
          resolvedSearch: resolvedSearch,
          records: $route.query.records
          }})"       
           ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :pagination.sync="pagination"
        :loading="isLoading"
        :items="resolvedList"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >

        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.currentStatus}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{props.item.id}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.ticketCategory.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >{{props.item.description}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >{{formatDate(props.item.dueDate)}}</h3>
            <h3
              class="grey--text font-weight-light"
              v-else
            >{{formatDate(props.item.dueDate)}} {{props.item.dueTime}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.importance}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{props.item.createdBy.name}} {{props.item.createdBy.surname}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !==null"
              class="grey--text font-weight-light"
            >{{props.item.assignedTo.name}} {{props.item.assignedTo.surname}}</h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !==null"
              class="grey--text font-weight-light"
            >{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</h3>
          </td>
        </template>
             <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedPage"
              :length="Math.ceil(resolvedTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

   <v-dialog v-model="filterModal" persistent max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">FILTER</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="filterModal=false">X</v-btn>
        </v-toolbar>
      
        <v-layout>
             <v-flex xs6 mx-2>
              <v-select clearable :items="statuses" label="Status" v-model="filterCurrentStatus"></v-select>
             </v-flex>
              <v-flex xs6 mx-2>  
               <v-select
              clearable
                :items="importanceOptions"
                label="Importance"
                v-model="filterImportance"
              ></v-select>
            </v-flex>
        </v-layout>
         <v-layout>
     <v-flex xs6 > 
        <v-menu>
                  <v-text-field
                  class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.filterStartDate)"
                    slot="activator"
                    label="Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="filterStartDate"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs6 > 
                <v-menu>
                  <v-text-field
                  class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.filterEndDate)"
                    slot="activator"
                    label="End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="filterEndDate"></v-date-picker>
                </v-menu>
            </v-flex>
            
        </v-layout>
        <v-layout>
                
            <v-flex xs6 mx-2>  
              <v-autocomplete 
                 v-model="filterAssignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assigned User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{item.name}} {{item.surname}}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item!=='undefined'"
                  >{{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}</v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3">{{item.name}} {{item.surname}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
               
               </v-flex>
        </v-layout>
               <v-btn flat class="primary" round  @click="clearFiltersButton()">Clear Filters</v-btn>
        <v-btn flat class="primary" round  @click="specifyTab()">Apply Filters</v-btn>
      </v-card>


  </v-dialog>

  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Calendar from "v-calendar/lib/components/calendar.umd";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { Drag, Drop } from "vue-drag-drop";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  props: [
    "tickets",
    "alltickets",
    "ticketcategories",
    "ticketcategoryitems",
    "users",
    "locations"
  ],
  components: {
    Calendar,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    Drag,
    Drop,
     loading: Loading,
  },
  data() {
    return {
      filterModal:false,
      ticketCategoryItems:[],
      ticketCategories:[],
      initialPending:[],
      initialResolved:[],
      filterPending: false,
      filterResolved: false,
      filterStartDate: null,
      filterEndDate: null,
      filterTicketCategory: null,
      filterTicketCategoryItem: null,
      filterCurrentStatus: null,
      filterImportance: null,
      filterAssignedToId: null,
      locationTypeId:null,
      locationNetworkId:null,
      locationNodeId:null,
      switchingCentreId:null,
      locationNetworks:[],
      locationNodes:[],
      switchingCentres:[],
      pendingPage: 1,
      pendingPagination: {},
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: {},
      resolvedSearch: "",
      resolvedTotalItems: 0,
      unassignedPage: 1,
      unassignedPagination: {},
      unassignedSearch: "",
      unassignedTotalItems: 0,
      loadingTicket:false,
      resolvedList: [],
      pendingList: [],
      unassignedList: [],
      addTemplate: false,
      ticketTemplates: [],
      isLoading: false,
      customData: {},
      headers: [
        {
          text: "Status",
          align: "center",
          value: "currentStatus"
        },
        {
          text: "Ticket ID",
          align: "center",
          value: "id"
        },
        {
          text: "Category",
          align: "center",
          value: "ticketCategoryItem.ticketCategory.name"
        },
        {
          text: "Subcategory",
          align: "center",
          value: "ticketCategoryItem.name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Due",
          align: "center",
          value: "dueDate"
        },
        {
          text: "Priority",
          align: "center",
          value: "importance"
        },
        {
          text: "Created By",
          align: "center",
          value: "createdBy.name"
        },
        {
          text: "Assigned To",
          align: "center",
          value: "assignedTo.name"
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy.name"
        }
      ],
      pagination1: {
        sortBy: "dueDate",
        descending: true
      },
      search: "",
      newDay: this.formatDate(new Date()),
      contactTableId: null,
      contacts: [],
      contactId: null,
      cardsPerPage: 2,
      resultCount: 0,
      currentPage: 1,
      activeTabName: "",
      key: 0,
      addTicketModal: false,
      editTicketModal: false,
      datePicker: false,
      timePicker: false,
      dateTimeSelect: true,
      addLocationModal: false,
      over: false,
      ticketItem: {},
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredLocations: [],
      filteredTickets: {},
      locationFilter: null,
      userSearch: "",
      comment: "",
      locationSearch: "",
      overData: null,
      initialAssignedId: null,
      locationType: "",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      today: this.formatDate(new Date()),
      tabs: [
        { name: "pending", displayName: "Pending" },
        { name: "resolved", displayName: "Resolved" }
      ],
     
    };
  },
  watch: {   
     "resolvedTotalItems":{
      immediate: true,
      async handler(value){
        this.tabs[1].array = value
        this.tabs[1].color = 'green'
        this.key++
      }
     },
     "pendingTotalItems":{
      immediate: true,
      async handler(value){
        this.tabs[0].array = value
        this.tabs[0].color = 'blue'
        this.key++
      }
     },
       "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(
            function(el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      }
    },
     filterPending(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "pending",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          assigned: this.filterAssignedToId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          offset: '0',
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterPending = false;
      }
    },
    filterResolved(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "resolved",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          assigned: this.filterAssignedToId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          offset: '0',
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterResolved = false;
      }
    },
     '$route.query':{
      immediate: true,
      async handler(value){
        this.pendingPage = 1
        this.resolvedPage = 1
        if(typeof value.currentStatus ==='undefined'){
          value.currentStatus=null
        }
        if(typeof value.importance ==='undefined'){
          value.importance=null
        }
        if(typeof value.currentStatus ==='undefined'){
          value.currentStatus=null
        }
        if(typeof value.importance ==='undefined'){
          value.importance=null
        }
        if(typeof value.category ==='undefined'){
          value.category=null
        }
        if(typeof value.categoryItem ==='undefined'){
          value.categoryItem=null
        }
        if(typeof value.assigned ==='undefined'){
          value.assigned=null
        }
        if(typeof value.startDate ==='undefined'){
          value.startDate=null
        }
        if(typeof value.endDate ==='undefined'){
          value.endDate=null
        }
        let currentStatus=value.currentStatus
        let importance = value.importance
        let category=value.category
        let categoryItem = value.categoryItem
        let assigned = value.assigned
        let startDate= value.startDate
        let endDate = value.endDate
        
        if(value.currentTab==='pending'){
          this.pendingList=this.initialPending
          
          if(currentStatus!==null){
            this.pendingList= await this.pendingList.filter(function(el){
              return el.currentStatus ===currentStatus
            })
          }
          if(importance!==null){
            this.pendingList=await this.pendingList.filter(function(el){
              return el.importance ===importance
            })
          }
          if(category!==null&&categoryItem!==null){
          this.pendingList=await this.pendingList.filter(function(el){
              return el.ticketCategoryItemId === categoryItem
            })
          }else if(category!==null&&categoryItem===null){
           this.pendingList=await this.pendingList.filter(function(el){
              return el.ticketCategoryItem.ticketCategoryId === category
            })
          }
          if(assigned!==null){
          this.pendingList=await this.pendingList.filter(function(el){
              return el.assignedToId === assigned
            })
          }
            if(startDate!==null){
           
            this.pendingList= await this.pendingList.filter(function(el){
              
              return el.dueDate >= startDate
            })
          }
          if(endDate!==null){
             var date = new Date(endDate);
             var day = 60 * 60 * 24 * 1000;
             var end = this.formatDate(new Date(date.getTime() + day))
            this.pendingList=await this.pendingList.filter(function(el){             
               return el.dueDate <= end
            })
          }
          this.pendingTotalItems=this.pendingList.length
        }

         if(value.currentTab==='resolved'){
          this.resolvedList=this.initialResolved
          
          if(currentStatus!==null){
            this.resolvedList= await this.resolvedList.filter(function(el){
              return el.currentStatus ===currentStatus
            })
          }
          if(importance!==null){
            this.resolvedList=await this.resolvedList.filter(function(el){
              return el.importance ===importance
            })
          }
            if(category!==null&&categoryItem!==null){
          this.resolvedList=await this.resolvedList.filter(function(el){
              return el.ticketCategoryItemId === categoryItem
            })
          }else if(category!==null&&categoryItem===null){
           this.resolvedList=await this.resolvedList.filter(function(el){
              return el.ticketCategoryItem.ticketCategoryId === category
            })
          }
          if(assigned!==null){
          this.resolvedList=await this.resolvedList.filter(function(el){
              return el.assignedToId === assigned
            })
          }
            if(startDate!==null){
            this.resolvedList= await this.resolvedList.filter(function(el){
              return el.dueDate >= startDate
            })
          }
          if(endDate!==null){
             var date = new Date(endDate);
             var day = 60 * 60 * 24 * 1000;
             var end = this.formatDate(new Date(date.getTime() + day))
            this.resolvedList=await this.resolvedList.filter(function(el){             
               return el.dueDate <= end
            })
          }
           this.resolvedTotalItems=this.resolvedList.length
        }
        }
     },
     // Pending Applications
    '$route.query.pendingSearch':{
      immediate: true,
      handler(value){
      if(this.$route.query.pendingSearch&&value!==""&&value != null){
      
          this.pendingPage = 1
        Api()
        .get('/ispTicket/active',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingList=response.data.result
          this.pendingTotalItems=response.data.count
          })

        } else if(this.$route.query.pendingOffset){            
             Api()
        .get('/ispTicket/active',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingList=response.data.result
          this.pendingTotalItems=response.data.count
            })
          }
      
      }
    },
    '$route.query.pendingOffset': {
       immediate: true,
      handler(value){
      if(value!==""&&value != null&&this.$route.query.pendingSearch&&this.$route.query.pendingSearch!="" &&this.$route.query.pendingSearch!== null){      
           Api()
        .get('/ispTicket/active',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingList=response.data.result
          this.pendingTotalItems=response.data.count
            })

      } else if(value != null){
          Api()
        .get('/ispTicket/active',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingList=response.data.result
          this.pendingTotalItems=response.data.count
            })
      }
    }
    },
     pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.resolvedSearch
            }
          });
        }
      }
    },
    // Resolved
    '$route.query.resolvedSearch':{
      immediate: true,
      handler(value){
      if(this.$route.query.resolvedSearch&&value!==""&&value != null){
       
             this.resolvedPage = 1
        Api()
        .get('/ispTicket/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedList=response.data.result
          this.resolvedTotalItems=response.data.count
          })
          }          
          else if(this.$route.query.resolvedOffset){
             Api()
        .get('/ispTicket/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedList=response.data.result
          this.resolvedTotalItems=response.data.count
            })
          }
      }
    },
    '$route.query.resolvedOffset': {
       immediate: true,
      handler(value){
      if(value!==""&&value != null&&this.$route.query.resolvedSearch&&this.$route.query.resolvedSearch!="" &&this.$route.query.resolvedSearch!== null){      
        
        Api()
        .get('/ispTicket/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedList=response.data.result
          this.resolvedTotalItems=response.data.count
            })
      }
      else if(value != null){
             Api()
        .get('/ispTicket/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedList=response.data.result
          this.resolvedTotalItems=response.data.count
            })
          }
      }
    },
     resolvedPage(value) {
       
      this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        }
      }
    },
    
  },
  created() {
       this.$router.push({
      name: this.$route.name,
      query: {
        pendingOffset: "0",
        resolvedOffset: "0",
        records: "15"
      }
    })
    this.loadingTicket=true
    this.setActiveTabName("pending");   
    this.fetchAllTickets()
    this.fetchOrgContacts();
     this.fetchTicketCategoryItems()
    this.fetchTicketCategories() 
    this.locationType = "End Location";
  },
  methods: {
       clearFiltersButton(){
            this.filterStartDate= null,
            this.filterEndDate= null,
            this.filterCurrentStatus= null,
            this.filterImportance= null,
            this.filterAssignedToId= null,
            this.specifyTab()
        },
      clearFilters(){
      this.filterModal=true
    },
       fetchTicketCategoryItems(){
            Api()
            .get('/ticketCategoryItem')
            .then(response=>{
                this.ticketCategoryItems = response.data
            })
        },
    fetchTicketCategories(){
      Api().get('/ticketCategory').then(response=>{
        this.ticketCategories = response.data
        this.loadingTicket=false
      })
    },
     fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async response => {
          this.filteredUsers = response.data.filter(function(el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map(x => x.contact);
          this.filteredUsers = contactArray;
        });
    },
     fetchAllTickets() {
       Api()
        .get('/ispTicket/active',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          }).then(response=>{
          this.initialPending=response.data.result
          })
         Api()
        .get('/ispTicket/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          }).then(response=>{
            this.initialResolved=response.data.result
          })
        },
    specifyTab() {
      if (this.displayContents('pending') === true) {
        this.filterPending = true;
      } else if (this.displayContents('resolved') === true) {
        this.filterResolved = true;
      }
    },
    
    async editTicket(item) {
      this.$router.push({ path: "/ispTicketSummary/" + item });
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },  
  }
};
</script>
<style>
.completeCard {
  border: 5px solid red;
}
.smallText {
  font-size: 10px;
}
.text {
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  size: 15px;
}
.longText {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  size: 15px;
}
.rounded-card {
  border-radius: 50px;
}
.custom {
  height: "100%" !important;
}
.custom_calendar .vc-day {
  border-right: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  padding: 3px;
}
.custom_calendar .on-top {
  border-top: 1px solid #aaa;
}
.custom_calendar .on-left {
  border-left: 1px solid #aaa;
}
.custom_calendar .event {
  word-wrap: break-word;
  word-break: break-all;
}
.custom_calendar .event-badge {
  white-space: normal;
  margin-top: 2px;
  text-align: left;
}
.event-badge {
  color: #fff;
}
.v-chip.complete {
  background: rgb(80, 189, 80);
}
.v-chip.incomplete {
  background: red;
}
.v-chip.pending {
  background: orange;
}
.v-chip.inprogress {
  background: lightblue;
}
.v-chip.normal {
  background: grey;
}
.v-chip.average {
  background: rgb(70, 128, 236);
}
.v-chip.notcritical {
  background: rgb(231, 137, 14);
}
.v-chip.urgent {
  background: red;
}
.dropClass {
  height: 100%;
  margin: 0;
}
.drop.over {
  border-color: #aaa;
  background: #ccc;
}
</style>